module.exports = __webpack_public_path__ + "img/address-book.575d21d6.svg";